import * as React from "react";
import { getGlobalVar } from "../../utils/helpers";

export const getAvatar = (avatarId) => {
    if (isNaN(parseInt(avatarId, 10))) {
        return <img src={avatarId}/>;
    }

    const avatar = getGlobalVar("ITEMS").find(config => config.id === +avatarId);

    if (!avatar) {
        return <img src={require(`../../../assets/images/misc/not_found.png`).default}/>;
    }

    try {
        avatar.image = require(`../../../assets/images/misc/not_found.png`).default;
    } catch (error) {
        avatar.image = require(`../../../assets/images/misc/not_found.png`).default;
    }

    if (avatar && avatar.id >= 21125) {
        return <div
            className="animated-avatar-large"
            style={{
                background: `url("${avatar.image}")`,
            }}
        />;
    }

    return <img
        src={avatar.image}
        style={{
            width: 70,
            height: 70
        }}
        onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = require(`../../../assets/images/misc/not_found.png`).default
        }}
    />;
}

const getAvatarFrame = (avatar_frame) => {
    try {
        const image = require(`../../../assets/images/misc/not_found.png`).default;

        return <img
            src={image}
            style={{
                width: 70,
                height: 70
            }}
            onError={(e: any) => {
                e.target.onerror = null;
                e.target.src = require(`../../../assets/images/misc/not_found.png`).default
            }}
        />
    } catch (error) {
        return null;
    }
}

export const InventoryIcon = ({
    itemId = null,
    style = {},
    amountStyle = {},
    amount = null
}) => {
    const imageStyle = {
        maxWidth: 40,
        ...style
    };

    try {
        const itemConfig = getGlobalVar("ITEMS").find(item => item.id === itemId);

        if (itemConfig.type === "avatars") {
            return getAvatar(itemId);
        }

        if (itemConfig.type === "avatar_frames") {
            return getAvatarFrame(itemId);
        }

        const image = require(`../../../assets/images/misc/not_found.png`)?.default;

        return <div style={{ position: "relative", display: "inline-block" }}>
            <img src={image} style={imageStyle}/>
            {amount !== null && <span style={{
                    position: "absolute",
                    bottom: "7%",
                    right: "0",
                    left: "10%",
                    width: "80%",
                    textAlign: "right",
                    fontWeight: 700,
                    fontSize: 20,
                    color: "#ffdd15",
                    textShadow: "1px 0 0 #000, 0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000",
                    ...amountStyle
                }}
                >
                    x{amount}
                </span>
            }
        </div>
    } catch (error) {
        return <img src={require(`../../../assets/images/misc/not_found.png`).default} style={imageStyle}/>;
    }
}
